












































































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { trim } from "@/util";
import Api from "../../../api/index";
import request from "../../../api/request";
import { SzgcProcessGetor, SzgcMobileGetor } from "@/index";
import { getCookie } from "@szgc/plt-core-v2";

@Component({
  name: "WbenchMine",
  components: {
    SzgcProcessGetor,
    SzgcMobileGetor
  }
})
export default class WbenchMine extends Vue {
  @Prop({
    type: String,
    default: "web"
  })
  private client!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  private topShow!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  private filterText: string = "";
  private treeData: any = [];
  private defaultProps: any = {
    label: "label",
    children: "children"
  };
  private typeId: any = "";
  private tempName: string = "";
  private sourceData: any = [];
  private tableData: any = [];
  private modalShow: boolean = false;
  private modalTitle: string = "";
  private flowInfo: any = {};
  private prefix: string = "";

  /*树搜索*/
  @Watch("filterText")
  private treeSearch(newVal: any) {
    if (this.$refs.wbenchMineTree) {
      (this.$refs.wbenchMineTree as any).filter(trim(newVal));
    }
  }

  /*表格搜索*/
  @Watch("tempName")
  private tableSearch(newVal: any) {
    if (trim(newVal) === "") {
      this.tableData = this.sourceData;
    } else {
      const temp: any = [];
      this.sourceData.map((item: any) => {
        if (item.templateName.indexOf(trim(newVal)) > -1) {
          temp.push(item);
        }
      });
      this.tableData = temp;
    }
  }

  async mounted() {
    this.prefix = getCookie("plt-api-route") || "";
    this.geTypeTree();
  }

  /*获取业务分类树*/
  async geTypeTree() {
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.geTypeTree,
        method: "get"
      });
      if (!success) {
        this.$message.error("获取业务分类树失败:" + message);
        return false;
      }
      let temp: any = [];
      if (data && data.length && data.length > 0) {
        temp = data;
      }
      temp.unshift({
        typeId: "",
        label: "最近使用模板",
        children: null
      });
      this.treeData = temp;
      this.$nextTick(() => {
        if (this.$refs.wbenchMineTree) {
          (this.$refs.wbenchMineTree as any).setCurrentKey(this.typeId);
        }
      });
      if (this.typeId === "") {
        this.getRecent();
      } else {
        this.getFlowPackages();
      }
    } catch (error: any) {
      this.$message.error("获取业务分类树失败:" + error);
    }
  }

  /*树过滤*/
  filterNode(value: any, data: any) {
    if (!value) return true;
    return data.label.indexOf(trim(value)) !== -1;
  }

  /*树点击*/
  nodeClick(val: any) {
    this.typeId = val.typeId;
    if (this.typeId === "") {
      this.getRecent();
    } else {
      this.getFlowPackages();
    }
  }

  /*获取最近使用模板*/
  async getRecent() {
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getRecent,
        method: "get"
      });
      if (!success) {
        this.$message.error("获取最近使用模板失败:" + message);
        return false;
      }
      let temp: any = [];
      if (data && data.length && data.length > 0) {
        temp = data;
      }
      this.sourceData = temp;
      this.tableData = temp;
    } catch (error: any) {
      this.$message.error("获取最近使用模板失败:" + error);
    }
  }

  /*获取流程包配置列表*/
  async getFlowPackages() {
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getFlowPackages({ typeId: this.typeId, clientType: "web" }),
        method: "get"
      });
      if (!success) {
        this.$message.error("获取我的模板列表失败:" + message);
        return false;
      }
      let temp: any = [];
      if (data && data.length && data.length > 0) {
        temp = data;
      }
      this.sourceData = temp;
      this.tableData = temp;
    } catch (error: any) {
      this.$message.error("获取我的模板列表失败:" + error);
    }
  }

  /*流程弹窗*/
  async showModal(flow: any) {
    this.modalTitle = "流程处理";
    this.flowInfo = {
      pacId: flow.pacId,
      businessId: flow.flowCfgId
    };
    this.modalShow = true;
  }

  /*流程弹窗关闭*/
  modalEvt(data: any) {
    this.$emit("childEvt", { data: data });
    this.modalShow = false;
  }
}
